import { JobService } from 'src/app/core/services/job.service';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';
import { RequisitionsQueryFilter } from './requisitions-query-filter.model';

export class RequisitionsInfiniteScrollContainer {
  requisitions: any[] = [];
  requisitionsPerPage: any[] = [];
  busy = false;
  loadingSearchButton = false;
  requisitionsExistFlag = true;
  currentPromise: any = null;
  disableInfiniteScroll = false;
  requisitionCount = 0;
  isFilterOn = false;
  requisitionsQueryFilter: RequisitionsQueryFilter;

  constructor(
    private userId: number,
    private companyId: number,
    private jobService: JobService,
    private alertsAndNotificationsService: AlertAndNotificationsService,
    private isStaffingCompany: boolean
  ) {}

  private _getRequisitions(successCallback: (data: any) => void, errorCallback: (error: any) => void) {
    this.currentPromise = this.jobService.searchJobsByText(
      this.userId,
      this.companyId,
      this.requisitionsQueryFilter.searchText,
      this.requisitionsQueryFilter,
      (data: any) => {
        if (successCallback) {
          successCallback(data);
        }
      },
      (error: any) => {
        if (errorCallback) {
          errorCallback(error);
        }
      }
    );
  }

  getNext() {
    if (this.busy) { return; }
    this.busy = true;

    if ((this.requisitionsQueryFilter.pageNum as any) === '') {
      this.requisitionsQueryFilter.pageNum = 1;
    }

    this._setIsFilterOn();
    this._getRequisitions(
      (data: any) => {
        if (data !== undefined && data !== 'user cancellation') {
          this.requisitionCount = data.totalCount;
          if (data.jobDetails.length > 0) {
            data.jobDetails.forEach((val: any) => {
              val.requisitionIndex = this.requisitions.length + 1;
              this.requisitions.push(val);
            });
            if (data.jobDetails.length < this.requisitionsQueryFilter.size) {
              this.disableInfiniteScroll = true;
            } else {
              this.requisitionsQueryFilter.pageNum++;
            }
          } else {
            this.disableInfiniteScroll = true;
          }
          this.requisitionsExistFlag = this.requisitions.length > 0;
        }
        this.busy = false;
        this.loadingSearchButton = false;
      },
      (error: any) => {
        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
      }
    );
  }

  getNextPage(currentPage: number) {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    if (this.busy) { return; }
    this.busy = true;

    this.requisitionsQueryFilter.pageNum = currentPage ? currentPage : 1;
    this.requisitionsPerPage = [];

    this._getRequisitions(
      (data: any) => {
        if (data !== undefined && data !== 'user cancellation') {
          this.requisitionCount = data.totalCount;
          data.jobDetails.forEach((val: any) => {
            this.requisitionsPerPage.push(val);
          });
          this.requisitionsExistFlag = this.requisitionsPerPage.length > 0;
        }
        this.busy = false;
        this.loadingSearchButton = false;
      },
      (error: any) => {
        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
      }
    );
  }

  private _setIsFilterOn() {
    const filter = this.requisitionsQueryFilter;
    if (
      filter.clientOrBU.length > 0 ||
      filter.roleList.length > 0 ||
      filter.requisitionNums.length > 0 ||
      filter.recruiters.length > 0 ||
      filter.requisitionTypes.length > 0 ||
      filter.jobTypes.length > 0 ||
      filter.requisitionStates.length > 0 ||
      filter.searchText.length > 0 ||
      (!filter.isAssignedToMe && this.isStaffingCompany) ||
      (!filter.isAssignedToOthers && this.isStaffingCompany) ||
      (!filter.isUnassigned && this.isStaffingCompany) ||
      (filter.sortColumn !== '' && filter.sortDirection !== '') ||
      filter.workLocationIds.length > 0
    ) {
      this.isFilterOn = true;
    } else {
      this.isFilterOn = false;
    }
  }
}
